module.exports = __webpack_public_path__ + "img/Calendar.1ee3e523.png";